import { ScreeningCaseCompositeEntity, ScreeningCaseReviewStatusKey } from '@nk/data-entities-lib';
import * as dayjs from 'dayjs';
import { ScreeningStatusTag } from './screening-overview.utils';

export const SCREENING_STATUS_TAG_CSS_CLASSES: Record<ScreeningStatusTag, string> = {
  pep_declined_flag: '',
  pep_flag: 'text-white colorize-bg-orange',
  pep_match_declined_flag: '',
  possible_pep_flag: 'text-black colorize-bg-yellow',
  possible_sanction_flag: 'text-white colorize-bg-red',
  sanction_flag: 'text-white colorize-bg-red',
  sanction_match_declined_flag: '',
  no_active_monitoring_connections_flag: 'text-white colorize-bg-cyan',
  pending_screening_actions_flag: 'text-white colorize-bg-cyan',
};

export const SCREENING_STATUS_TAG_ICONS: Record<ScreeningStatusTag, string | null> = {
  pep_declined_flag: null,
  pep_flag: 'fa-info-circle',
  pep_match_declined_flag: null,
  possible_pep_flag: null,
  possible_sanction_flag: null,
  sanction_flag: 'fa-info-circle',
  sanction_match_declined_flag: null,
  no_active_monitoring_connections_flag: null,
  pending_screening_actions_flag: null,
};

export function isAllScreeningCaseReviewsCompleted(composite: ScreeningCaseCompositeEntity): boolean {
  if (!composite) {
    return false;
  }
  if (composite.screening_case_review_composites?.length > 0) {
    return composite.screening_case_review_composites.every(
      (caseReview) =>
        caseReview.screening_case_review_status?.screening_case_review_status_key ===
        ScreeningCaseReviewStatusKey.complete,
    );
  } else {
    return false;
  }
}

export function getLatestScreeningCaseReviewCompositeEntity<
  T extends { screening_case_review: { created_timestamp?: Date } },
>(items: T[]): T | null {
  if (!(items && items.length)) {
    return null;
  }
  return items.sort(
    (a, b) =>
      dayjs(b.screening_case_review.created_timestamp).valueOf() -
      dayjs(a.screening_case_review.created_timestamp).valueOf(),
  )[0];
}
